// src/components/frontend/Refund.js
import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { pageService } from '../../services/api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faShieldAlt, 
    faExclamationTriangle, 
    faCheckCircle,
    faInfoCircle 
} from '@fortawesome/free-solid-svg-icons';

const Refund = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const response = await pageService.getRefund();
            setData(response.data.data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching refund data:', error);
            // Fallback data with updated content
            setData({
                title: 'Refund Policy',
                content: 'Indian News Paper & Media Association maintains a strict no-refund policy for all membership fees and event registrations. All payments made to the association are final and non-refundable under any circumstances.',
                last_updated: '2026-09-01',
                sections: [
                    {
                        title: 'No Refund Policy',
                        description: 'All membership fees, event registration fees, and any other payments made to Indian News Paper & Media Association are strictly non-refundable. Once a payment is processed, it cannot be reversed or refunded.'
                    },
                    {
                        title: 'Membership Fees',
                        description: 'Membership fees are non-refundable regardless of whether the member chooses to continue or terminate their membership. This includes all types of memberships - Professional, Student, Life, and Corporate memberships.'
                    },
                    {
                        title: 'Event Registrations',
                        description: 'All event registration fees are non-refundable. Once registered for an event, the fee cannot be refunded, even if the participant is unable to attend the event.'
                    },
                    {
                        title: 'Payment Confirmation',
                        description: 'By making a payment to Indian News Paper & Media Association, you acknowledge and agree to this no-refund policy. All payments are considered final upon completion.'
                    }
                ]
            });
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <section className="py-5">
            <Container>
                <Row className="mb-5">
                    <Col className="text-center">
                        <h1 className="display-4 fw-bold">{data.title}</h1>
                        <div className="divider mx-auto" style={{ width: '60px', height: '4px', background: 'linear-gradient(90deg, #0056b3, #007bff)', marginBottom: '2rem' }} />
                    </Col>
                </Row>

                <Row>
                    <Col lg={12}>
                        <Card className="shadow-sm border-0 bg-light mb-4">
                            <Card.Body className="p-4">
                                <div className="d-flex align-items-center mb-3">
                                    <FontAwesomeIcon 
                                        icon={faExclamationTriangle} 
                                        size="2x" 
                                        className="text-danger me-3"
                                    />
                                    <h3 className="fw-bold mb-0">Important Notice</h3>
                                </div>
                                <p className="lead text-danger fw-bold">
                                    {data.content}
                                </p>
                            </Card.Body>
                        </Card>

                        {data.sections && data.sections.map((section, index) => (
                            <Card key={index} className="shadow-sm border-0 mb-4">
                                <Card.Body className="p-4">
                                    <div className="d-flex align-items-start">
                                        <div className="me-3 mt-1">
                                            {index === 0 && (
                                                <FontAwesomeIcon 
                                                    icon={faShieldAlt} 
                                                    size="lg" 
                                                    className="text-primary"
                                                />
                                            )}
                                            {index === 1 && (
                                                <FontAwesomeIcon 
                                                    icon={faInfoCircle} 
                                                    size="lg" 
                                                    className="text-primary"
                                                />
                                            )}
                                            {index === 2 && (
                                                <FontAwesomeIcon 
                                                    icon={faInfoCircle} 
                                                    size="lg" 
                                                    className="text-primary"
                                                />
                                            )}
                                            {index === 3 && (
                                                <FontAwesomeIcon 
                                                    icon={faCheckCircle} 
                                                    size="lg" 
                                                    className="text-primary"
                                                />
                                            )}
                                        </div>
                                        <div>
                                            <h4 className="fw-bold mb-2">{section.title}</h4>
                                            <p className="text-muted mb-0">{section.description}</p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        ))}

                        <Card className="shadow-sm border-0 bg-primary text-white">
                            <Card.Body className="p-4 text-center">
                                <h4 className="fw-bold mb-3">Important Information</h4>
                                <p className="mb-0">
                                    Please carefully review this policy before making any payment. 
                                    By making a payment, you agree to these terms and conditions.
                                </p>
                            </Card.Body>
                        </Card>

                        <div className="mt-4 text-muted text-center">
                            <p className="small">
                                <strong>Last Updated:</strong> {data.last_updated}
                            </p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default Refund;